import { render, staticRenderFns } from "./UserBillingAddresses.vue?vue&type=template&id=2a747520&scoped=true"
import script from "./UserBillingAddresses.vue?vue&type=script&lang=ts"
export * from "./UserBillingAddresses.vue?vue&type=script&lang=ts"
import style0 from "./UserBillingAddresses.vue?vue&type=style&index=0&id=2a747520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a747520",
  null
  
)

export default component.exports